export default "__VITE_ASSET__76491ac2__"